import { Day, Schedule } from "./types";
import { DAYS } from "./constants";
import { copyEventsToDay, getDayEnabledRange } from "./utils";

interface ScheduleActions {
  copyFromPreviousDay: (dayIndex: number) => void;
  deleteEvent: (day: Day, eventIndex: number) => void;
}

// Acciones de calendario compartidas entre la vista de escritorio y la móvil.
export function useScheduleActions(
  value: Schedule,
  onChange: (schedule: Schedule) => void,
  weekdaysEnabled: boolean,
  weekendEnabled: boolean
): ScheduleActions {
  const copyFromPreviousDay = (dayIndex: number) => {
    if (dayIndex === 0) return;
    const prevDay = DAYS[dayIndex - 1];
    const sourceEvents = value[prevDay.key] || [];
    if (sourceEvents.length === 0) return;
    const day = DAYS[dayIndex];
    const range = getDayEnabledRange(day, weekdaysEnabled, weekendEnabled);
    if (!range) return;
    const currentEvents = value[day.key] || [];
    const copiedEvents = copyEventsToDay(sourceEvents, range);
    if (copiedEvents.length === 0) return;
    onChange({ ...value, [day.key]: [...currentEvents, ...copiedEvents] });
  };

  const deleteEvent = (day: Day, eventIndex: number) => {
    const newSchedule = { ...value };
    const dayRanges = [...(newSchedule[day.key] || [])];
    dayRanges.splice(eventIndex, 1);
    if (dayRanges.length === 0) {
      delete newSchedule[day.key];
    } else {
      newSchedule[day.key] = dayRanges;
    }
    onChange(newSchedule);
  };

  return { copyFromPreviousDay, deleteEvent };
}
